import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';
import { useNodeUserQuery } from '../../queries';

export const useDirectMessage = () => {
  // TODO: fix navigate - it should not be defined inside a feature
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const isEnabled = Boolean(userId);
  const { data, isFetching } = useNodeUserQuery({ railsId: userId }, { enabled: isEnabled });

  useEffect(() => {
    if (isEnabled && data && !isFetching) {
      void navigate(routes.chat.create, {
        state: { userToChat: { email: data.email, firstName: data.firstName, id: data._id, lastName: data.lastName } },
      });
    }
  }, [isEnabled, data, isFetching, navigate]);

  const handleDirectMessage = useCallback(({ id }: { id: string }) => {
    setUserId(id);
  }, []);

  return {
    handleDirectMessage,
    isFetching,
  };
};
